<!--
 * @Author: your name
 * @Date: 2020-07-24 20:08:42
 * @LastEditTime: 2020-08-04 18:49:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/pages/account/login/login.vue
-->
<template>
  <div class="login">
    <div class="login-logo">
      <img src="@/assets/logo.png" alt="logo">
    </div>
    <div class="login-content">
      <component :is="loginComponent" @toggle="handleToggle" @success="handleSuccess"></component>
    </div>
  </div>
</template>

<script>
import PlainLogin from './plain-login/plain-login'
import PhoneLogin from './phone-login/phone-login'
import { mapMutations, mapState } from 'vuex'
import {
  SET_USER_INFO,
  SET_TOKEN
} from '@/store/auth.store.js'
import {
  SET_CURRENT_DEPARTMENT
} from '@/store/tenant.store.js'
import apis from '@/api'

const LOGIN_COMPONENTS = {
  PlainLogin,
  PhoneLogin
}
export default {
  components: {
    ...LOGIN_COMPONENTS
  },
  inject: ['getBlankRouter'],
  data() {
    return {
      loginComponent: 'PlainLogin'
    }
  },
  computed: {
    ...mapState({
      openId: (state) => state.oauthModule.openId,
      unionId: (state) => state.oauthModule.unionId
    })
  },
  methods: {
    ...mapMutations('authModule', {
      setUserInfo: SET_USER_INFO,
      setToken: SET_TOKEN
    }),
    ...mapMutations('tenantModule', {
      setCurrentDepartment: SET_CURRENT_DEPARTMENT
    }),
    handleToggle(componentName) {
      if (componentName in LOGIN_COMPONENTS) {
        this.loginComponent = componentName
      }
    },
    handleSuccess(data) {
      this.setToken(data.token)
      this.setUserInfo(data.user)
      this.setCurrentDepartment(data.userDepartment)
      const blankRouter = this.getBlankRouter()
      if (blankRouter) {
        this.$router.push(blankRouter)
      } else {
        if (data.tenantId) {
          // 判断是否在微信中且存在openId
          const ua = window.navigator.userAgent.toLowerCase()
          if (ua.match(/micromessenger/i) != null && this.unionId) {
            if (data.xdapAccountMapping && data.xdapAccountMapping.wxUnionId) {
              this.$router.replace({ name: 'workbench', params: { orgId: data.tenantId } })
            } else {
              // 调用绑定微信openid的接口
              this.bindwxOffice(this.openId, this.unionId, data.tenantId)
            }
          } else {
            this.$router.replace({ name: 'workbench', params: { orgId: data.tenantId } })
          }
        } else {
          this.$router.replace({ name: 'org-setting' })
        }
      }
    },
    bindwxOffice(openId, unionId, tenantId) {
      const request = { ...apis.ACCOUNT.BIND_WX_OFFICE }
      request.params = {
        openId: openId,
        unionId: unionId
      }
      this.$request(request).asyncThen((resp) => {
        if (resp.code === 'ok') {
          this.$router.replace({ name: 'workbench', params: { orgId: tenantId } })
        }
      }, (err) => {
        console.error(err)
      }).asyncErrorCatch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style lang="scss">
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  background-color: $--app-box-bgColor;
  .login-logo {
    width: 14.29rem;
    height: 3.71rem;
    margin-bottom: 9rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login-content {
    width: 100%;
    padding: 1rem 2rem;
    box-sizing: border-box;
  }
}
</style>
